import { SocialGroupForPointsLiterals } from '@inkitt/titan/types/SocialGroupForPoints';
import { z } from 'zod';

export const CoinsForSocialGroup = z.partialRecord(z.enum(SocialGroupForPointsLiterals), z.boolean());

export type CoinsForSocialGroup = z.infer<typeof CoinsForSocialGroup>;
